export const TOGGLE_MAP = 'TOGGLE_MAP';
export const HOTEL_DATA_FETCHED = 'HOTEL_DATA_FETCHED';
export const FETCH_HOTEL_DATA = 'FETCH_HOTEL_DATA';
export const SET_POPUP_DATA = 'SET_POPUP_DATA';
export const RESET_POPUP_DATA = 'RESET_POPUP_DATA';
